import React, { useEffect, useState } from "react";
import "./Compare.css";
import Header from "./Header";
import Footer from "./Footer";


function Compare(){

const [products,setProducts] = useState([]);
const [loading,setLoading] = useState(true);



const fetchCompareList = async () => {

try{

const guestId = localStorage.getItem("guest_id");

const res = await fetch(
"https://aethearia.store/superadmin/api/compareList",
{
method:"POST",
headers:{
"Content-Type":"application/json"
},
body:JSON.stringify({
guest_id:guestId
})
}
);


const data = await res.json();

console.log("Compare List:",data);


if(data.status){
setProducts(data.data || []);
}

}
catch(error){
console.log("Compare list error",error);
}
finally{
setLoading(false);
}

};



useEffect(()=>{

fetchCompareList();

},[]);





const removeCompare = async(compareId)=>{


try{


const res = await fetch(
"https://aethearia.store/superadmin/api/removeCompare",
{
method:"POST",
headers:{
"Content-Type":"application/json"
},
body:JSON.stringify({

compare_id:Number(compareId)

})
}
);


const data = await res.json();


console.log("Remove Response:",data);


if(data.status){

fetchCompareList();

}


}
catch(error){

console.log("Remove compare error",error);

}


};




if(loading){

return <>

<Header/>

<div className="compare-page">

<h2 className="heading">
Loading Compare Products...
</h2>

</div>

<Footer/>

</>

}



return(
<>
<Header/>

<div className="compare-page">


<div className="compare-container">




{products.length === 0 ? (
  <div className="empty-compare">
    <h2>There is no product in compare</h2>
    <p>Add products to compare and view them here.</p>

    <button
      className="add-product-btn"
      onClick={() => window.location.href = "/shop-all"}
    >
      Add Product
    </button>
  </div>
) : (
    <div className="compare-container">
    <h1 className="heading">
Compare Product
</h1>
  <table className="compare-table">


<thead>

<tr>

<th>Image</th>
<th>Product Name</th>
<th>Scent Family</th>
<th>Wax Weight</th>
<th>Burn Time</th>
<th>Variant SKU</th>
<th>Price</th>
<th>Action</th>

</tr>

</thead>



<tbody>


{
products.length > 0 ?

products.map((item,index)=>(


<tr key={index}>


<td>

<img
src={`https://aethearia.store/superadmin/uploads/products/Hero/${item.hero_image}`}
alt={item.product_name}
/>

</td>



<td className="product-name">

{item.product_name}

<p>
{item.short_description}
</p>

</td>



<td>

{item.scent_family}

</td>



<td>

{item.wax_weight}g

</td>



<td>

{item.burn_time || "-"}

</td>



<td>

{item.variant_sku}

</td>



<td className="compare-price">

₹
{
item.offer_price > 0
?
item.offer_price
:
item.price
}

</td>



<td>

<button

className="remove"

onClick={()=>removeCompare(item.compare_id)}

>

✕


</button>


</td>



</tr>


))

:

<tr>

<td colSpan="8">

No products added for compare

</td>

</tr>

}


</tbody>


  </table>


</div>
)}

</div>
</div>


<Footer/>

</>
)

}


export default Compare;